/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteSpenderListInfo = {
    RK: string;
    ADT: KiteSpenderListInfo.ADT;
    ADDR: string;
    TGU: string;
    TS: string;
    TRXCNT: string;
    TF: string;
    LTRXUT: number;
};

export namespace KiteSpenderListInfo {

    export enum ADT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

